import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 14,
    marginLeft: indent / 2,
    fontWeight: '600',
  },
  optaText: {
    fontSize: 14,
    fontWeight: '700',
  },
  description: {
    marginTop: indent / 2,
  },
  link: {
    color: denim,
    fontWeight: '600',
  },
  icon: {
    fontSize: 20,
  },
});
